@if (
	{
		fontsLoaded: fontsLoaded$ | async,
		sessionLoaded: sessionLoaded$ | async,
		loaded: loaded$ | async,
	};
	as vm
) {
	<div class="w-100 h-100 fc-800" [class.bg-190]="vm.loaded" style="transition: background 300ms">
		@if (vm.loaded) {
			<router-outlet></router-outlet>
		}
	</div>
	@if (!vm.loaded) {
		<div class="pos-abs pos-t-0 posl-0 w-100 h-100 fl fl-ai-c fl-jc-c bg-190">
			<screen-initialization (close)="_onAppInitialized()"></screen-initialization>
		</div>
	}
}
